"use strict";

var _interopRequireDefault = require("/mnt/www/planning-web-v2/node_modules/@babel/runtime/helpers/interopRequireDefault.js");

require("core-js/modules/es6.reflect.construct");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _classCallCheck2 = _interopRequireDefault(require("/mnt/www/planning-web-v2/node_modules/@babel/runtime-corejs2/helpers/classCallCheck.js"));

var _createClass2 = _interopRequireDefault(require("/mnt/www/planning-web-v2/node_modules/@babel/runtime-corejs2/helpers/createClass.js"));

var _inherits2 = _interopRequireDefault(require("/mnt/www/planning-web-v2/node_modules/@babel/runtime-corejs2/helpers/inherits.js"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("/mnt/www/planning-web-v2/node_modules/@babel/runtime-corejs2/helpers/possibleConstructorReturn.js"));

var _getPrototypeOf2 = _interopRequireDefault(require("/mnt/www/planning-web-v2/node_modules/@babel/runtime-corejs2/helpers/getPrototypeOf.js"));

var _tslib = require("tslib");

var _vuePropertyDecorator = require("vue-property-decorator");

var _elementUi = require("element-ui");

var _lastMileDelivery = require("@/mixins/last-mile-delivery/last-mile-delivery");

var _translation = require("@/mixins/translation/translation");

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var LMDOrderDateRangeAutoAssignComponent = /*#__PURE__*/function (_Mixins) {
  (0, _inherits2.default)(LMDOrderDateRangeAutoAssignComponent, _Mixins);

  var _super = _createSuper(LMDOrderDateRangeAutoAssignComponent);

  function LMDOrderDateRangeAutoAssignComponent() {
    (0, _classCallCheck2.default)(this, LMDOrderDateRangeAutoAssignComponent);
    return _super.apply(this, arguments);
  }

  (0, _createClass2.default)(LMDOrderDateRangeAutoAssignComponent, [{
    key: "onDateRangeChanges",
    value: function onDateRangeChanges() {
      this.$resetPlan();
      this.$selectedLocation = null;
      this.$locationType = this.$defaultLocationType;
      this.$getOrderLocationLists({
        'locationType': this.$defaultLocationType,
        'startTime': this.$startDate,
        'endTime': this.$endDate
      });
    }
  }]);
  return LMDOrderDateRangeAutoAssignComponent;
}((0, _vuePropertyDecorator.Mixins)(_lastMileDelivery.LastMileDeliveryMixin, _translation.TranslationMixin));

LMDOrderDateRangeAutoAssignComponent = (0, _tslib.__decorate)([(0, _vuePropertyDecorator.Component)({
  name: 'LMDOrderDateRangeAutoAssignComponent',
  components: {
    'el-date-picker': _elementUi.DatePicker,
    'el-form': _elementUi.Form,
    'el-form-item': _elementUi.FormItem,
    'el-select': _elementUi.Select,
    'el-option': _elementUi.Option,
    'el-row': _elementUi.Row,
    'el-col': _elementUi.Col,
    'el-tooltip': _elementUi.Tooltip
  }
})], LMDOrderDateRangeAutoAssignComponent);
var _default = LMDOrderDateRangeAutoAssignComponent;
exports.default = _default;